import { createSelector } from '@reduxjs/toolkit';
import { selectSelectionsForSelectedReport } from 'app/area/favourite/selectors';
import { mapToSelectionValue } from 'app/area/reports/containers/group-by/map-to-store';
import { selectGroupByFieldState } from 'app/area/reports/selectors';

export const selectSelectionFieldItemsForCurrentReport = (instanceKey: string) => {
  const selectionsSelector = selectSelectionsForSelectedReport(instanceKey);
  const mappedSelections = createSelector([selectionsSelector], (({selections, rollingAverage}) =>
    selections?.map((s, i) => mapToSelectionValue(s, i === 0 ? rollingAverage : undefined))  
  ));
  const groupByFieldStateSelector = selectGroupByFieldState(instanceKey);

  return createSelector(
    [groupByFieldStateSelector, mappedSelections],
    (groupByFieldState, mappedSelectionsResult) => {
      
      return mappedSelectionsResult
        ?.map(s => ({
          ...s,
          field: {
            ...s.field,
            showMissingValues: groupByFieldState?.selectionTypeInformation?.[s?.field?.value]?.showMissingValues
          },
          selectionTypes: groupByFieldState?.selectionTypeInformation?.[s?.field?.value]?.selectionTypes
        })) ?? [];
    }
  );
};
